namespace Matrix.Data {
    export interface PartyRelationshipForm {
        PartyCode: Serenity.StringEditor;
        RelationshipTypeCode: FormatLookupEditor;
        RelatedPartyCode: FormatLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class PartyRelationshipForm extends Serenity.PrefixedContext {
        static formKey = 'Matrix.Data.Forms.PartyRelationshipForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PartyRelationshipForm.init)  {
                PartyRelationshipForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(PartyRelationshipForm, [
                    'PartyCode', w0,
                    'RelationshipTypeCode', w1,
                    'RelatedPartyCode', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
